<template>
  <ThemeDefaultContainerSection
    :title="modelValue.title"
    title-underline
    :description="modelValue.description"
  >
    <ThemeDefaultCardGalleryDisplay
      data-allow-mismatch
      class="tw-block tw-mt-8 lg:tw-mt-12"
      :items="modelValue.content"
      action-event-name="Preview - Home"
      fb-event-name="Gallery - Home"
      event-name="home"
    />
  </ThemeDefaultContainerSection>
</template>

<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: Object as () => HomeSection<GalleryMeta[]>,
    required: true,
  },
})
</script>
